/* eslint-disable no-console */
import React from 'react';
import {useState} from 'react';

import ReactGA from 'react-ga';

function Contact() {
  const [email, setEmail] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [isSent, setIsSent] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isNotSuccess, setIsNotSuccess] = useState(false);
  const [noValue, setNoValue] = useState(0);

  const Event = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  function handleChange(e) {
    setEmail({
      ...email,
      [e.target.name]: [e.target.value],
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    const templateId = process.env.REACT_APP_TEMPLATE_ID;
    console.log(templateId);

    console.log();

    if (email.email && email.message && email.name) {
      if (email.message[0]?.length < 25) {
        setNoValue(2);
      } else {
        Event('CONTACT', 'Contact button is pressed', 'CONTACT_FORM');
        sendMessage(templateId, {
          message_html: email.message,
          from_name: email.name,
          reply_to: email.email,
        });
        setNoValue(0);
      }
    } else {
      setNoValue(1);
    }
  }

  function sendMessage(templateId, variables) {
    setIsSent(true);

    window.emailjs
      .send('gmail', templateId, variables)
      .then((res) => {
        console.log('Email successfully sent!');
        Event('CONTACT', 'Message is successful', 'CONTACT_FORM');
        setTimeout(() => {
          setIsSuccess(true);
        }, 800);
      })
      // Handle errors here however you like, or use a React error boundary
      .catch((err) => {
        console.error(
          'Oh well, you failed. Here some thoughts on the error that occured:',
          err,
        );
        setTimeout(() => {
          setIsNotSuccess(true);
          Event('CONTACT', "Message is wasn't successful", 'CONTACT_FORM');
        }, 800);
      });
  }

  const confirmMessage = () => {
    if (isSent) {
      if (isSuccess) {
        return <p>Message sent! I'll respond within 24 hours.</p>;
      } else if (isNotSuccess) {
        return <p>Problem sending message. Please try again later.</p>;
      } else {
        return <p>Sending message...</p>;
      }
    }

    if (noValue === 1) {
      return <p>Please don't leave fields blank.</p>;
    } else if (noValue === 2) {
      return <p>Due to increase spam, I have set the minimum character length to 25!</p>;
    }
  };

  return (
    <section id="contact" className="px-10 py-4 m-auto bg-white sm:shadow-md sm:w-2/3">
      <h2 className="w-full text-3xl font-bold ">Contact</h2>
      <form className="flex flex-col" method="POST">
        <label className="font-semibold" htmlFor="name">
          Name
        </label>
        <input
          className="p-1 border border-gray-700 rounded"
          type="text"
          name="name"
          value={email.name}
          onChange={handleChange}
          id="name"
        />

        <label className="font-semibold" htmlFor="email">
          Email
        </label>
        <input
          id="email"
          className="p-1 border border-gray-700 rounded"
          type="email"
          name="email"
          value={email.email}
          onChange={handleChange}
        />

        <label className="font-semibold" htmlFor="message">
          Message
        </label>
        <textarea
          id="message"
          className="p-1 border border-gray-700 rounded"
          name="message"
          rows="3"
          value={email.message}
          onChange={handleChange}
        ></textarea>

        <div role="alert" aria-live="assertive">
          {confirmMessage()}
        </div>

        {isSent ? (
          <input
            className="w-32 py-1 mt-3 font-semibold text-white bg-red-700 rounded-full opacity-50 cursor-not-allowed focus:border-black focus:border-8"
            type="submit"
            disabled
            value="Submit"
            onClick={handleSubmit}
          />
        ) : (
          <input
            className="w-32 py-1 mt-3 font-semibold text-white bg-red-700 rounded-full cursor-pointer hover:bg-red-900"
            type="submit"
            value="Submit"
            onClick={handleSubmit}
          />
        )}
      </form>
    </section>
  );
}

export default Contact;
